import { getData, postData, putData } from "./rest-api-helper";

export async function getAllTrkOp() {
    const details = {
        urlPath: "/truckOp"
    }

    const res = await getData(details);
    // console.log(res, "---------------getAllTrkOp");
    return res;
}

export async function getTrkOpLedger({ truckopId, fromDate, toDate }) {
    const details = {
        urlPath: "/truckOp/ledger",
        queryParams: { truckopId, fromDate, toDate }
    }
    const res = await getData(details);
    return res || { broughtForward: 0, rows: [] };
}

export async function putTrkOpStatus(truckOpId, status) {
    const details = {
        urlPath: "/truckOp",
        queryParams: { truckopId: truckOpId, status }
    }
    const res = await putData(details);
    // console.log(res + "---------------putTrkOpStatus");
    return res;
}

export async function getSingleTrkOp(truckOpId) {
    const details = {
        urlPath: `/truckOp/getSingle/${truckOpId}`
    }

    const res = await getData(details);
    // console.log(res, "---------------getSingleTrkOp");
    return res;
}

export async function getSingleTrk(trkId) {
    const details = {
        urlPath: `/truckOp/truck/${trkId}`
    }

    const res = await getData(details);
    // console.log(res, "---------------getSingleTrk");
    return res;
}

export async function getAllTrkOpWPgSch({ limit, pageNumber, searchKeyWord, fromDate, toDate }) {
    const details = {
        urlPath: "/truckOp",
        queryParams: {
            limit,
            offset: (pageNumber * limit) - limit,
            ...(searchKeyWord && { searchKeyWord })
        }
    }
    let res = await getData(details);

    const details2 = {
        urlPath: "/truckOp",
        queryParams: {
            limit: 10000, // Fetch all for client-side filtering
            offset: 0,
            ...(searchKeyWord && { searchKeyWord })
        }
    }
    let res2 = await getData(details2);

    // console.log(res, "---------------getAllTrkOpWPgSch");

    let finalData = res ? res : [];
    let finalCount = res2?.length;

    if (fromDate && toDate && res2 && res2.length > 0) {
        // Fetch reports to get dates (workaround for missing date in List API)
        const reportData = await getAllTrkOpRepts({ limit: 10000, pageNumber: 1 });
        const dateMap = {};
        if (reportData?.data) {
            reportData.data.forEach(r => {
                const id = r.truckopId || r.truckOpId || r.trkOpId || r.id;
                if (id) dateMap[id] = r.trkOpRegDate;
            });
        }

        const from = new Date(fromDate);
        const to = new Date(toDate);
        to.setHours(23, 59, 59, 999);

        const filtered = res2.filter(item => {
            const id = item.truckopId || item.truckOpId || item.trkOpId || item.id;
            const dateStr = dateMap[id] || item.trkOpRegDate || item.createdAt || item.created_at || item.date;

            if (!dateStr) return false;
            const itemDate = new Date(dateStr);
            return itemDate >= from && itemDate <= to;
        });

        finalCount = filtered.length;

        // Paginate locally
        const start = (pageNumber - 1) * limit;
        const end = start + limit;
        finalData = filtered.slice(start, end);
    }

    return {
        totalLength: finalCount,
        data: finalData
    }
}

export async function getAllTrksByTpId(trkOpId) {
    if (!trkOpId)
        return []

    const details = {
        urlPath: `/truckOp/getAllTrucks`,
        queryParams: { trkOpId }
    }

    const res = await getData(details);
    // console.log(res, "---------------getAllTrksByTpId");
    return res || [];
}

export async function addtruck(data) {
    const details = {
        urlPath: "/truckOp/truck",
        body: {
            ...data
        }
    }

    const res = await postData(details);
    // console.log(res, "---------------addtruck");
    return res;
}

export async function putTruck(trkId, data) {
    const details = {
        urlPath: "/truckOp/truck/" + trkId,
        body: {
            ...data
        }
    }
    const res = await putData(details);
    // console.log(res + "---------------putTruck");
    return res;
}

export async function createTrkOp(data) {
    const details = {
        urlPath: "/truckOp/create",
        body: {
            ...data
        }
    }
    const res = await postData(details);
    // console.log(res, "---------------createTrkOp");
    return res;
}

export async function putTrkOp(trkOpId, data) {
    const details = {
        urlPath: "/truckOp/edit/" + trkOpId,
        body: {
            ...data
        }
    }
    const res = await putData(details);
    // console.log(res + "---------------putTrkOp");
    return res;
}

export async function putTrkStatus(trkId, status) {
    const details = {
        urlPath: status === 1 ? "/truckOp/enableTrk" : "/truckOp/disableTrk",
        queryParams: { trkId: trkId }
    }
    const res = await putData(details);
    // console.log(res + "---------------putTrkStatus");
    return res;
}

export async function getAllTrkOpRepts({ trkOp, trkRegNo, order, limit, pageNumber, fromDate, toDate }) {

    let queryParamsObj = {
        trkOp, trkRegNo, order, fromDate, toDate
    }

    // console.log(queryParamsObj)

    const details = {
        urlPath: "/truckOp/report",
        queryParams: {
            ...queryParamsObj,
            limit,
            offset: (pageNumber * limit) - limit,

        }
    }
    let res = await getData(details);

    const details2 = {
        urlPath: "/truckOp/report",
        queryParams: {
            ...queryParamsObj,
            limit: 1000,
            offset: 0,
        }
    }
    let res2 = await getData(details2);

    // console.log(res, "---------------getAllTrkOpRepts");
    return {
        totalLength: res2?.count || (Array.isArray(res2) ? res2.length : 0),
        data: Array.isArray(res) ? res : (Array.isArray(res?.result) ? res.result : [])
    }
}

export async function getTpReqPymtRept({ trkOp, order, fromDate, toDate, limit, pageNumber, truckStatus, mat }) {
    const offset = (pageNumber * limit) - limit;
    const details = {
        urlPath: "/truckOp/reqPymtRept",
        queryParams: {
            trkOp, order, fromDate, toDate, truckStatus, mat, limit, offset
        }
    }
    const res = await getData(details);
    return {
        totalLength: res?.count || 0,
        data: Array.isArray(res?.result) ? res.result : []
    }
}

export async function getTrkOpReqRept({ time, searchKeyWord, searchType, order, fromDate, toDate, limit, pageNumber }) {
    const offset = (pageNumber * limit) - limit;
    const details = {
        urlPath: "/request/trkReqRept",
        queryParams: {
            time, searchKeyWord, searchType, order, fromDate, toDate, limit, offset
        }
    }
    const res = await getData(details);
    return {
        totalLength: res?.count || 0,
        data: Array.isArray(res?.result) ? res.result : []
    }
}

export async function putTrkOpBankDetails(trkOpId, data) {
    const details = {
        urlPath: `/truckOp/bankDetails/${trkOpId}`,
        body: {
            bankName: data.bankName, branch: data.branch, accNo: data.accNo, ifsc: data.ifsc
        }

    }

    const res = await putData(details);
    // console.log(res + "---------------putTrkOpBankDetails");
    return res;
}

export async function getAllPenTrks({ vfyStatus, order, limit, pageNumber }) {
    let queryParamsObj = {
        vfyStatus,
        order
    }

    // console.log(queryParamsObj)

    const details = {
        urlPath: "/truckOp/allPendingTrks",
        queryParams: {
            ...queryParamsObj,
            limit,
            offset: (pageNumber * limit) - limit,

        }
    }
    let res = await getData(details);
    const details2 = {
        urlPath: "/truckOp/allPendingTrks",
        queryParams: {
            ...queryParamsObj
        }
    }
    let res2 = await getData(details2);

    // console.log(res, "---------------getAllPenTrks");
    return {
        totalLength: res2 ? res2?.length : 0,
        data: res ? res : []
    }
}

export async function putTrkVfyStatus({ trkId, vfyStatus }) {
    const details = {
        urlPath: `/truckOp/truckVfyStatus/${trkId}`,
        body: {
            vfyStatus
        }

    }
    const res = await putData(details);
    // console.log(res + "---------------putTrkVfyStatus");
    return res;
}

export async function getAllDelTrkOpWPgSch({ limit, pageNumber, searchKeyWord }) {
    const details = {
        urlPath: "/truckOp/getAllDelTruckOp",
        queryParams: {
            limit,
            offset: (pageNumber * limit) - limit,
            ...(searchKeyWord && { searchKeyWord })
        }
    }
    let res = await getData(details);

    const details2 = {
        urlPath: "/truckOp/getAllDelTruckOp",
        queryParams: {
            // limit: 100000000000000,
            // offset: 0,
            ...(searchKeyWord && { searchKeyWord })
        }
    }
    let res2 = await getData(details2);

    // console.log(res, "---------------getAllDelTrkOpWPgSch");

    return {
        totalLength: res2?.length,
        data: res ? res : []
    }
}